<template lang="pug">
  .tag
    ul(v-if="tagData")
      Tag(closable color="blue"
        v-for="(item, index) in tagData"
        :key="index"
        @on-close="handleClose(index)") {{item}}
      Button(type="text" v-show='clickAdd' @click="addTag") 点击添加
      Input(:maxlength="50"
        v-show="!clickAdd"
        style="width: 80px"
        ref="addInput"
        placeholder="限制50字"
        @on-blur='fun_addTag'
        v-model.trim='addTagData'
        @keyup.enter.native="fun_addTag")
</template>

<script>
export default {
  data() {
    return {
      clickAdd: true,
      addTagData: ""
    };
  },
  props: {
    tagData: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },
  methods: {
    // 点击添加标签
    addTag() {
      this.clickAdd = false;
      this.$nextTick(() => {
        this.$refs.addInput.focus();
      });
    },
    // 添加标签
    fun_addTag() {
      const value = this.addTagData.trim();
      if (!value) {
        this.clickAdd = true;
      } else {
        this.tagData.push(value);
        this.clickAdd = true;
        this.addTagData = "";
      }
    },
    // 关闭标签
    handleClose(value) {
      this.tagData.splice(value, 1);
    }
  }
};
</script>

<style lang="stylus">
.tag
  border 1px solid rgb(220, 222, 226)
  text-align left
  border-radius 4px
  padding 4px
  ul
    .ivu-tag
      height 28px
      line-height 28px
      background rgba(58, 118, 210, 1)
      .ivu-tag-text
        color #FFF !important
</style>
